import {i18n} from '@netx/core-next/locales/i18n-instance';

export const getCategoryCollisionError = (type: string, code: any) =>
	i18n.t('i18n.errorRequestFailed');

export const getCategoryCreateError = (type: string, code: any) =>
	i18n.t('i18n.errorRequestFailed');
